import React, { useState, useEffect, useRef } from "react";
import "./Project.css";

function Project({ title, description, techName, liveLink, links, coverPhoto }) {
  const [isactive, setIsActive] = useState(false);
  const projectsRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const handleIntersect = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsActive(true);
        } else {
          setIsActive(false);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(projectsRef.current);

    // Cleanup observer on component unmount
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      className={`project-container ${isactive ? "project-active" : ""} `}
      id="projects"
      ref={projectsRef}
    >
      <div className="project-left-container">
        <a href={`${liveLink}`} target="_blank" rel="noreferrer">
          <img src={coverPhoto} alt="demsteam-project" />
        </a>
      </div>
      <div className="project-right-container">
        <h2>{title}</h2>
        <h5>{description}</h5>
        <div className="project-tools">
          <h3>Tech Used:</h3>
          <div>
            {techName.map((tech, index) => (
              <h6 key={index}>{tech}</h6>
            ))}
          </div>
        </div>
        {links && links.length > 0 ? (
          <div className="project-links">
            {links.map((link, index) => (
              <a
                key={index}
                className="live-btn"
                href={link.url}
                target="_blank"
                rel="noreferrer"
                style={{ marginRight: '10px', marginBottom: '5px' }}
              >
                {link.label}
              </a>
            ))}
          </div>
        ) : (
          <a
            className="live-btn"
            href={`${liveLink}`}
            target="_blank"
            rel="noreferrer"
          >
            Visit Live
          </a>
        )}
      </div>
    </div>
  );
}

export default Project;
